var map = {
	"./document-icon-excel.jpg": 8726,
	"./document-icon-file.jpg": 5353,
	"./document-icon-pdf.jpg": 315,
	"./document-icon-ppt.jpg": 2381,
	"./document-icon-txt.jpg": 2837,
	"./document-icon-word.jpg": 6981,
	"./document-icon-zip.jpg": 7622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9890;